import {createSvgIcon} from "../../../icons/create-svg-icon";

export const IndeterminateCheckboxFilledIcon = createSvgIcon(
  <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M17,13H7v-2h10V13z" />,
  'CheckBox'
);
